import i18n from '@/lib/i18n'

export const LINEUP_TITLE = i18n.t('lineup.title')
